import { useQuery } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { api } from '../../../../lib/apiClient';
import { credentialKeys } from './queryKeys';

export const useGetCredentials = () =>
  useQuery({
    queryKey: credentialKeys.list(),
    queryFn: () =>
      api.unpaginatedRequest(endpoints.integrationCredentials.list)({}),
  });
